
export type State = {
  layers: {
    others: boolean,
    pattern: boolean,
    warehouses: boolean,
    borderPoints: boolean,
  }
}

export enum ActionNames {
  updateLayer = 'updateLayer',
}

export type Action = { type: ActionNames.updateLayer, payload: object }